import "./Button.scss";
import React, { CSSProperties, useMemo } from "react";
import { LoadingOutlined } from "@ant-design/icons";

export type ButtonType =
  | "Primary"
  | "Secondary"
  | "SecondaryDark"
  | "LinkDark"
  | "Tertiary"
  | "TertiaryDark"
  | "Link"
  | "LinkPrimary"
  | "Cancel"
  | "Quaternary";
export type ButtonSize = "Small" | "Large";

export interface ButtonProps {
  type?: ButtonType;
  size?: ButtonSize;
  disabled?: boolean;
  loading?: boolean;
  inverted?: boolean;
  children: JSX.Element | string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  id?: string;
  backgroundColor?: string;
  textColor?: string;
}

export function Button({
  children,
  onClick,
  type,
  size,
  loading,
  disabled,
  className,
  id,
  inverted,
  backgroundColor,
  textColor,
}: ButtonProps) {
  let _className = "btn ant-btn";

  if (type === "Primary") _className += " primary";
  else if (type === "Secondary") _className += " secondary";
  else if (type === "SecondaryDark") _className += " secondary-dark";
  else if (type === "LinkDark") _className += " link-dark";
  else if (type === "Tertiary") _className += " tertiary";
  else if (type === "TertiaryDark") _className += " tertiary-dark";
  else if (type === "Link") _className += " link";
  else if (type === "LinkPrimary") _className += " link-primary";
  else if (type === "Cancel") _className += " cancel";
  else if (type === "Quaternary") _className += " quaternary";

  if (size === "Small") _className += " small";
  if (size === "Large") _className += " large";

  if (inverted) _className += " inverted";

  const customStyle = useMemo(() => {
    const style = {} as CSSProperties;

    if (backgroundColor) {
      style.backgroundColor = backgroundColor;
    }
    if (textColor) {
      style.color = textColor;
    }

    return style;
  }, [backgroundColor, textColor]);

  return (
    <button
      id={id}
      className={`${_className} ${className || ""}`}
      onClick={onClick}
      disabled={loading || disabled}
      style={customStyle}
    >
      {!loading ? <><span className="loading-span"/>{children}</> : ""}
      {loading ? <><span className={`loading-span ${loading ? "loading" : ""}`}><LoadingOutlined/></span>{children}</> : ""}
    </button>
  );
}
